export const LS_KEY_ENGAGEMENT_SCOPE_NEW_ACTIVITY_URL = "engagement-scope-new-activity-url";
